import { useState, useEffect } from "react";
import { X, Images } from "lucide-react";
import { useTranslation } from "react-i18next";

export function PlatformCheck({ active, onClick, icon: Icon, label, subtitle, color, tid }) {
  return (
    <button onClick={onClick} data-testid={tid}
      className={`inline-flex items-center gap-3 px-4 py-3 rounded-2xl border transition-all ${active ? "border-[color:var(--sp-brand)] bg-white shadow-sm" : "border-[color:var(--sp-border)] bg-white/50 hover:bg-white"}`}>
      <div className={`h-9 w-9 rounded-xl flex items-center justify-center ${active ? "bg-[color:var(--sp-subtle)]" : "bg-neutral-100"}`}>
        <Icon className={`h-5 w-5 ${active ? color : "text-neutral-400"}`} />
      </div>
      <div className="text-left">
        <div className={`text-sm font-bold ${active ? "text-[color:var(--sp-text-primary)]" : "text-neutral-500"}`}>{label}</div>
        <div className="text-[10px] text-[color:var(--sp-text-muted)]">{subtitle}</div>
      </div>
      <div className={`ml-3 h-5 w-5 rounded-md border-2 flex items-center justify-center ${active ? "bg-[color:var(--sp-brand)] border-[color:var(--sp-brand)]" : "border-neutral-300"}`}>
        {active && <svg className="h-3 w-3 text-white" viewBox="0 0 20 20" fill="currentColor"><path d="M16.7 5.3a1 1 0 0 1 0 1.4l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 1 1 1.4-1.4L9 11.6l6.3-6.3a1 1 0 0 1 1.4 0z"/></svg>}
      </div>
    </button>
  );
}

export function Field({ label, icon: Icon, children }) {
  return (
    <div>
      <label className="text-xs font-bold text-[color:var(--sp-text-secondary)] flex items-center gap-1.5 mb-1">
        {Icon && <Icon className="h-3.5 w-3.5" />} {label}
      </label>
      {children}
    </div>
  );
}
export function StatusPill({ status }) {
  const { t } = useTranslation();
  const map = {
    published: "bg-emerald-100 text-emerald-700",
    scheduled: "bg-blue-100 text-blue-700",
    draft: "bg-slate-100 text-slate-600",
    error: "bg-red-100 text-red-700",
  };
  const known = ["published", "scheduled", "draft", "error"];
  const label = known.includes(status) ? t(`publish.status.${status}`) : status;
  return <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${map[status] || "bg-neutral-100 text-neutral-600"}`}>{label}</span>;
}

// ==========================================================================
// Drafts list — bozze e programmati (non ancora pubblicati)
// ==========================================================================
export function EmptyPreview() {
  const { t } = useTranslation();
  return (
    <div className="sp-card p-8 text-center">
      <Images className="h-8 w-8 mx-auto text-[color:var(--sp-text-muted)] mb-2" />
      <div className="text-sm text-[color:var(--sp-text-muted)]">
        {t("publish.emptyPreview")}
      </div>
    </div>
  );
}

export function AvatarFallback({ letter, className = "h-9 w-9 text-sm" }) {
  return (
    <div className={`${className} rounded-full bg-gradient-to-br from-neutral-300 to-neutral-500 flex items-center justify-center text-white font-bold`}>
      {letter}
    </div>
  );
}
